import script from "./RadioButtonWithLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioButtonWithLabel.vue?vue&type=script&setup=true&lang=js"

import "./RadioButtonWithLabel.vue?vue&type=style&index=0&id=02727e5a&lang=css"

const __exports__ = script;

export default __exports__